import { useMemo } from "react";
import { loadCustomSegmentsMetadataWrapper } from "app/pages/segments/config/segmentsConfigHelpers";

// HOC that loads [fetch] segments
export const WithSegmentsLoading = (Component) =>
    function (props) {
        useMemo(loadCustomSegmentsMetadataWrapper, []);
        return <Component {...props} />;
    };
